
import { createSlice } from '@reduxjs/toolkit';
import { fetchAlreadySelectedProductIds } from '../../api/alreadySelectedProductApi';

const initialState = {
  alreadySelectedProductIds: [],
  loading: false,
  error: null,
};

const alreadySelectedProductSlice = createSlice({
  name: 'alreadyselectedproducts',
  initialState,
  reducers: {
     resetAlreadySelectedProductState: (state) => {
      state.alreadySelectedProductIds = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAlreadySelectedProductIds.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAlreadySelectedProductIds.fulfilled, (state, action) => {
        state.loading = false;
        state.alreadySelectedProductIds = action.payload;
      })
      .addCase(fetchAlreadySelectedProductIds.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});


export const {
  resetAlreadySelectedProductState,
} = alreadySelectedProductSlice.actions;



export default alreadySelectedProductSlice.reducer;
